import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Index from '../components/index.vue';
import Product from '../components/product.vue';
import Solution from '../components/Solution.vue';
import News from '../components/news.vue';
import New from '../components/new.vue';
import About from '../components/About.vue';
import Contact from '../components/contact.vue';
import productDetail from '../components/productDetail.vue';





Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    children: [
      {
        path: '/',
        component:Index
      },
      {
        path: '/product',
        component: Product
      },
      {
        path: '/solution',
        component: Solution
      },
      {
        path: '/news',
        component: News
      },
      {
        path: '/new',
        component: New
      },
      {
        path: '/about',
        component: About
      },
      {
        path: '/contact',
        component: Contact
      },
      {
        path: '/productDetail',
        component: productDetail
      },
    ]
  },
];


const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果 savedPosition 是一个精确的位置，就用它
    if (savedPosition) {
      return savedPosition;
    } else {
      // 如果不是，就返回顶部
      return { x: 0, y: 0 };
    }
  }
});

export default router;
